<div class="main-container">
  <div>
    <div class="img-container">
      <button type="button" aria-label="Close modal" (click)="closeModal()">
        <img src="assets/img/x.svg" alt="close" class="close">
      </button>
    </div>
    <div class="px-3">
      @if (title) {
        <h4 class="title">{{title | translate}}</h4>
      }
      @if (description) {
        <p class="description">{{description | translate}}</p>
      }
    </div>
  </div>

  <div class="range-scale-container">
    @if (scaleTitle) {
      <div class="scale-text">{{ scaleTitle | translate}}</div>
    }
    <div class="slider-wrapper">
      <div class="zones">
        @for (zone of zones; track zone; let i = $index) {
          <div class="zone" [ngStyle]="getZoneStyle(zone)">
          </div>
        }
      </div>
      <ngx-slider [options]="sliderOptions" class="custom-slider">
      </ngx-slider>
    </div>
  </div>

</div>